(function() {
    'use strict';
    angular
        .module('ordiniApp')
        .factory('Operazione', Operazione);

    Operazione.$inject = ['$resource'];

    function Operazione ($resource) {
        var resourceUrl =  'api/operaziones/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();
